<template>
  <li v-if="customersOnlineCount" class="nav-item d-flex align-items-center px-1 px-lg-3">
    <small v-shtml="$t('eLt_coustomersOnlineCount')" />
    <span class="h4 m-0 ml-3">
      <span class="male">
        <font-awesome-icon icon="person" /> {{ displayClientsCount }}</span>
      <span class="female">
        <font-awesome-icon icon="person-dress" /> {{ displayHostessesCount }}
      </span>
    </span>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CustomersOnline',
  computed: {
    ...mapGetters({
      customersOnlineCount: 'staffUser/customersOnlineCount',
      clientsOnlineCount: 'staffUser/clientsOnlineCount',
      hostessesOnlineCount: 'staffUser/hostessesOnlineCount'
    }),
    displayClientsCount () {
      return this.stringify(this.clientsOnlineCount)
    },
    displayHostessesCount () {
      return this.stringify(this.hostessesOnlineCount)
    }
  },
  methods: {
    stringify (val) {
      let mod = ''
      if (val > 999999) {
        val = Math.floor(val / 1000000)
        mod = 'M'
      } else if (val > 999) {
        val = Math.floor(val / 1000)
        mod = 'k'
      }
      return `${val}${mod}`
    }
  }
}
</script>

<style scoped>
  .male {
    color: rgb(69, 191, 202);
  }
  .female {
    color: rgb(202, 69, 120);
  }
</style>
